<template>
  <div class="outStorage-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toGoodsStorage">商品出库/</span>出库详情
      </template>
      <template v-slot:content>
        <div class="outStorage-detail-main">
          <div class="list">
            <ul class="list-ul">
              <li class="list-ul-li">单号：{{ list.number }}</li>
              <li class="list-ul-li">出库时间：{{ list.date }}</li>
              <li class="list-ul-li">操作人：{{ list.userName }}</li>
              <li class="list-ul-li">仓库：{{ list.warehouse }}</li>
            </ul>
          </div>
          <div class="table-img">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="date" label="主图">
                <template slot-scope="scope">
                  <el-image class="img" fit="contain" :src="scope.row.img" lazy></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称">
                <template slot-scope="scope">
                  <p class="name">{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="商品编码"></el-table-column>
              <el-table-column prop="specifications" label="商品规格"></el-table-column>
              <el-table-column prop="number" label="出库数量"></el-table-column>
            </el-table>
            <div class="sum">
              <p>合计：</p>
              <p class="sum-number">{{ sum }}</p>
            </div>
          </div>
          <div class="remarks">
            <span>备注：</span>
            <span>{{list.description }}</span>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBInventory from "models/db/inventory.js";
const dbInventory = new DBInventory();
export default {
  data() {
    return {
      id: null,
      list: "",
      tableData: [
        // {
        //   img: '图片',
        //   name: '华硕(ASUS) 飞行堡垒6 15.6英寸窄边框游戏笔记本',
        //   code: '54867274',
        //   specifications: '红色，16G',
        //   number: 154
        // }
      ],
      sum: 0 // 合计
    };
  },
  components: {
    SecondMenuLinkContent
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      let width = document.getElementsByClassName("cell").item(2).offsetWidth;
      document.getElementsByClassName("sum-number").item(0).style.width =
        width + "px";
    });
  },
  methods: {
    // 返回上一页
    toGoodsStorage() {
      this.$router.push("leave-storage");
    },
    // 根据id获取当前页数据
    getData() {
      let id = this.id;
      dbInventory.getDBOutStockDetail(id).then(res => {
        if (res.success) {
          let obj = {};
          obj.number = res.result.storageOutOrder.outStockCode;
          obj.warehouse = res.result.storageOutOrder.warehouseName;
          obj.userName = res.result.storageOutOrder.head;
          obj.date = this.toDate(res.result.storageOutOrder.outStockTime);
          obj.description = res.result.storageOutOrder.message;
          this.list = obj;
          // console.log(res.result.items);
          // let arr = this.evil(res.result.items);
          // console.log(res.result);
          // console.log(res.result.items);
          // console.log(JSON.parse(res.result.items));
          // let arr2 = [];
          res.result.storageOutGoodsList.map((value, index, array) => {
            let object = {};
            object.img = value.goodsPic
              ? value.goodsPic
              : "http://image.8844it.com/ydb2/goodDefault.png";
            object.name = value.goodsName;
            object.code = value.goodsCode;
            object.specifications = "";
            object.number = value.quantity;
            this.sum += value.quantity;
            let specInfo = JSON.parse(value.itemTitle);
            let str = "";
            Object.keys(specInfo).map(key => {
              str += specInfo[key] + ";";
            });
            object.specifications = str.slice(0, str.length - 1);
            this.tableData.push(object);
          });
        }
      });
    },
    evil(fn) {
      let Fn = Function; // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn("return " + fn)();
    },
    // 日期转换
    toDate(val) {
      let date = new Date(val);
      var year = date.getFullYear(); // 取得四位数的年份
      var month = date.getMonth() + 1; // 返回0~11之间的数字，0代表一月，11代表12月
      var day = date.getDate();
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<style lang="scss" scoped>
.outStorage-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .outStorage-detail-main {
    .list {
      margin-bottom: 24px;
      .list-ul {
        display: flex;
        align-items: center;
        font-size: 14px;
        .list-ul-li {
          line-height: 24px;
          color: #606266;
          min-width: 240px;
        }
      }
    }
    .table-img {
      margin-bottom: 24px;
      .sum {
        border: 1px solid #f2f6fc;
        border-top: 0;
        padding-left: 16px;
        line-height: 32px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        .sum-number {
          box-sizing: border-box;
          padding: 0 16px;
        }
      }
    }
    .remarks {
      font-size: 14px;
      color: #606266;
    }
  }
}
</style>
<style lang="scss">
.outStorage-detail {
  .outStorage-detail-main {
    .table-img {
      .el-table .el-table__body-wrapper {
        .el-table__body {
          tr {
            td {
              .cell {
                .name {
                  width: 158px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
